<div class="course-details-breadcrumb-1 bg_image rts-section-gap">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="single-course-left-align-wrapper">
          <div class="meta-area">
            <a class="text-white" [routerLink]="['/']">Início</a>
            <i class="fa-solid fa-chevron-right text-white"></i>
            <a class="active text-white" [routerLink]="['/infraestrutura']"
              >Infraestrutura</a
            >
          </div>
          <h1 class="title text-white">Conheça a Infraestrutura</h1>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="about-area-start style-two mb--200">
  <div class="container">
    <p class="paragraph">
      A infraestrutura da Faculdade Facint foi cuidadosamente planejada para
      proporcionar um ambiente educacional confortável, seguro e
      tecnologicamente avançado. Nossos espaços são modernos, acessíveis e
      pensados para atender às necessidades de aprendizagem ativa, promovendo a
      integração entre teoria e prática. Cada detalhe foi concebido para
      oferecer aos estudantes as condições ideais para o desenvolvimento de
      competências acadêmicas, profissionais e humanas, em um ambiente que
      estimula a criatividade, o pensamento crítico e a convivência
      colaborativa.
    </p>
  </div>
</div>
